import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Alert } from '../../shared/alert/alert';
import { Card } from '../../shared/card/card';
import { IPaymentCardCommonData } from '../../../models/common/payments';
import { MeatballsMenu } from '../../shared/meatballs-menu/meatballs-menu';
import { CardType } from '../../../constants/payments';
import { IMAGES_ASSETS_URL } from '../../../constants/links';
import { useMeatballMenuActions } from '../../../hooks/use-meatball-payment-actions';

interface IProXtraDollarCardProps {
  card: IPaymentCardCommonData;
}

export const ProXtraDollarCard = ({ card }: IProXtraDollarCardProps) => {
  const { onViewPurchases } = useMeatballMenuActions();

  const isExpired = (date: string | undefined) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return date ? new Date(date) < today : false;
  };

  const b2bMenuItems = [
    {
      value: 'View Purchases',
      action: () => {
        onViewPurchases(card, CardType.PRO_XTRA_DOLLARS);
      },
      isHidden: !card.actions?.viewPurchases,
    },
  ];

  return (
    <>
      <Card isDefault={card.isDefault} defaultLabel="Default Payment Method">
        <div
          className={`sui-flex sui-justify-between sui-align-center ${
            card.cardNickName ? 'sui-mb-2' : 'sui-mb-3'
          }`}
        >
          <h3 className="sui-font-display sui-text-3xl sui-mr-4">
            {card.cardNickName}
          </h3>
          <div>
            <MeatballsMenu label="Payment" items={b2bMenuItems} />
          </div>
        </div>
        <div className="sui-flex sui-mb-6">
          <img
            width={40}
            height="auto"
            className="sui-inline-block sui-mr-4"
            src={`${IMAGES_ASSETS_URL}/pro-xtra-rewards.png`}
            alt="ProXtra card logo"
          />
          <div className="sui-mr-4">
            <Typography variant="body-lg" color="subtle">
              -{card.cardNumberLast4}-
            </Typography>
          </div>
          {card.rewardExpDate && (
            <Typography variant="body-lg" color="subtle">
              {`Exp ${card.rewardExpDate}`}
            </Typography>
          )}
        </div>
        {isExpired(card.rewardExpDate) && <Alert status="error">Expired</Alert>}
        {card.gcBalance && (
          <Typography variant="body-lg" weight="bold" color="primary">
            Balance ${card.gcBalance}
          </Typography>
        )}
        {card.rewardStartDate && (
          <Typography variant="body-lg" color="primary">
            Earned Date {card.rewardStartDate}
          </Typography>
        )}
      </Card>
    </>
  );
};
ProXtraDollarCard.displayName = 'ProXtraDollarCard';
